<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import GoldenTickets from '~/components/modal-windows/GoldenTickets.vue'

defineProps<{
  goldenTicketsCount: number | null
}>()

async function openGoldenTicketsModalWindow (): Promise<void> {
  await useModal({ component: GoldenTickets }).open()
}
</script>

<template>
  <span v-if="goldenTicketsCount" class="golden-tickets-count inline-flex items-baseline">
    <SvgIcon class="mr-1" name="outlined/confirmation-number" />
    <span>{{ goldenTicketsCount }}</span>
    <SvgIcon
      class="golden-tickets-count__help-outline-icon ml-1"
      name="outlined/help-outline"
      @click="openGoldenTicketsModalWindow"
    />
  </span>
</template>

<style lang="scss" scoped>
@use 'assets/css/variables';

.golden-tickets-count {
  color: variables.$main-yellow-color;
  font-size: 18px;

  &__help-outline-icon:hover {
    color: variables.$main-blue-color;
    cursor: pointer;
  }

  svg {
    align-self: center;
  }
}
</style>
